// extracted by css-extract-rspack-plugin
var _1 = "w_pZA7Lyls8Fb1rW";
var _2 = "UKrXaDzVoJIk7pKW";
var _3 = "InGnYkTEUbc5frZa";
var _4 = "rPrb8ZUohuUof1IE";
var _5 = "V2qgMaYHLw4dDMFd";
var _6 = "IwjWnVKWJLMGiN3R";
var _7 = "piZB1Jpd58vfRGjX";
var _8 = "JDRlXqJ37r0XWwpx";
var _9 = "OI8iN_FhKpgaTjmm";
var _a = "hOGBhF2j6l8ULvhT";
var _b = "Joh0bLhCvQ4T9pqm";
var _c = "sY22lpKlUQuk_iSM";
var _d = "BhYK1mBpPIy7LYjF";
var _e = "eIKZ6Z3b6kdrqJw9";
var _f = "aGd8DAh3Eyv4MrzY";
var _10 = "tsxXKnDdC5Mjoaf8";
var _11 = "h7vgUfxonImQxCw_";
var _12 = "XpDqfcPUN1kYNDkp";
var _13 = "sXhCavv2vSs_AoZd";
var _14 = "WpikOaXsNVQZeK7w";
var _15 = "O3zHlupfxs498wFv";
var _16 = "i0PQQK1MDEIKYkvS";
var _17 = "rutxIu4wf46yW4n7";
var _18 = "G7hvguKHbnw79YE2";
var _19 = "QObBq_65B5YlqT7D";
var _1a = "dwCJYS882YI2d1Gc";
var _1b = "kAWSKbZO_4stUHRk";
export { _1 as "brivityBlue", _2 as "brivityOrange", _3 as "darkBlue", _4 as "gray", _5 as "grayBase", _6 as "intentBuyer", _7 as "intentCandidate", _8 as "intentLandlord", _9 as "intentNone", _a as "intentRecruit", _b as "intentSeller", _c as "intentSellerBuyer", _d as "intentTenant", _e as "statusActiveClient", _f as "statusArchived", _10 as "statusHot", _11 as "statusInactive", _12 as "statusNew", _13 as "statusNurt", _14 as "statusOther", _15 as "statusPast", _16 as "statusPending", _17 as "statusProspectiveClient", _18 as "statusTrash", _19 as "statusUnqual", _1a as "statusWatch", _1b as "yellowOrange" }
